<template>
  <div>
    <div class="contentArea">
      <AgGrid />
    </div>
  </div>
</template>

<script>
import AgGrid from "./elements/ag-grid-table/AgGridTable";

import { mapGetters } from "vuex";

export default {
  components: {
    AgGrid,
  },
  computed: {
    ...mapGetters({ nowSlug: "getNowSlug", tabActive: "general/tabActive" }),
  },

  mounted() {
    // console.log();
    // this.$store.dispatch("general/getTab", this.nowSlug);
    // this.$store.dispatch("general/getTable", "fourth");
  },
  watch: {
    tabActive(newValue) {
      this.$store.dispatch("general/getTable", newValue.path);
    },
  },
};
</script>
